import React from "react";
import { Accordion, Badge, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

/*
|--------------------------------------------------------------------------
| GROUP WISE SAVINGS vs LOANS
|--------------------------------------------------------------------------
|
| Admin sees how much each group saved and to whom / for what
| purpose the loans were given.
|--------------------------------------------------------------------------
*/

const formatMoney = (number) =>
  `PKR ${Number(number || 0).toLocaleString("en-PK", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;

const formatDate = (date) => {
  if (!date) {
    return "-";
  }

  const parsedDate = new Date(date);

  return isNaN(parsedDate.getTime())
    ? date
    : parsedDate.toLocaleDateString("en-GB");
};

const getImageUrl = (image) => {
  if (!image) {
    return "";
  }

  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }

  return `${process.env.REACT_APP_IMG_URL || ""}${image}`;
};

function GroupLoansTable({ groups = [] }) {
  return (
    <div className="mc-card mb-4">
      <div className="mc-breadcrumb" style={{ marginBottom: "10px" }}>
        <h3 className="mc-breadcrumb-title">
          GROUP SAVINGS & LOANS
        </h3>
      </div>

      {groups.length === 0 ? (
        <div className="text-center text-muted py-4">
          No loans have been given yet.
        </div>
      ) : (
        <Accordion alwaysOpen>
          {groups.map((group, index) => (
            <Accordion.Item eventKey={String(index)} key={group.id}>
              <Accordion.Header>
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <strong>
                    {group.group_name}
                    {group.group_code ? ` (${group.group_code})` : ""}
                  </strong>

                  <Badge bg="success">
                    Saved: {formatMoney(group.total_savings)}
                  </Badge>

                  <Badge bg="primary">
                    Loaned: {formatMoney(group.total_loans)}
                  </Badge>

                  <Badge bg={group.balance < 0 ? "danger" : "secondary"}>
                    Balance: {formatMoney(group.balance)}
                  </Badge>

                  <Badge bg="dark">
                    {group.loans.length} Loans
                  </Badge>
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <div className="table-responsive">
                  <Table bordered hover className="mb-2">
                    <thead
                      style={{
                        backgroundColor: "#077834",
                        color: "#fff",
                      }}
                    >
                      <tr>
                        <th>#</th>
                        <th>Member</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Time Period</th>
                        <th>Purpose</th>
                        <th>Evidence</th>
                      </tr>
                    </thead>

                    <tbody>
                      {group.loans.map((loan, loanIndex) => (
                        <tr key={loan.id}>
                          <td>{loanIndex + 1}</td>
                          <td>
                            <strong>{loan.member_name || "-"}</strong>
                          </td>
                          <td>{formatMoney(loan.amount)}</td>
                          <td>{formatDate(loan.loan_date)}</td>
                          <td>{loan.time_period || "-"}</td>
                          <td>
                            <Badge bg="primary">
                              {loan.purpose_text || loan.purpose}
                            </Badge>
                          </td>
                          <td>
                            {loan.evidence ? (
                              <a
                                href={getImageUrl(loan.evidence)}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={getImageUrl(loan.evidence)}
                                  alt="Evidence"
                                  style={{
                                    width: "60px",
                                    height: "45px",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                  }}
                                />
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <Link
                  to={`/act-groups/loans/${group.id}`}
                  style={{ color: "#077834", fontWeight: "bold" }}
                >
                  Open group loans →
                </Link>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </div>
  );
}

export default GroupLoansTable;
